import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { ContentfulCloudinaryImage } from '../../../../core/interfaces/Contentful/CloudinaryImage/ContentfulCloudinaryImage';

@Component({
  standalone: true,
  selector: 'app-contentful-cloudinary-picture',
  templateUrl: './contentful-cloudinary-picture.component.html',
  styleUrls: ['./contentful-cloudinary-picture.component.scss'],
})
export class AppContentfulCloudinaryPictureComponent implements OnChanges {
  @Input() customStyles?: Record<string, any> = {};
  @Input() cloudinaryBackgroundImageAsset?: ContentfulCloudinaryImage;
  @Input() cloudinaryBackgroundImageMobileAsset?: ContentfulCloudinaryImage;

  cloudinaryBackgroundImageUrl?: string;
  cloudinaryBackgroundImageAlt?: string;
  cloudinaryBackgroundImageMobileUrl?: string;
  cloudinaryBackgroundImageMobileAlt?: string;
  desktopImageSrcSet?: string;
  mobileImageSrcSet?: string;

  ngOnChanges(changes: SimpleChanges): void {
    // This cast is safe because the @Input() type is ContentfulCloudinaryImage, ensuring that the value passed have the correct structure.
    const image = changes.cloudinaryBackgroundImageAsset?.currentValue as ContentfulCloudinaryImage;
    this.cloudinaryBackgroundImageUrl = image?.asset?.fields.file?.url;
    this.cloudinaryBackgroundImageAlt = image?.alternateText ?? '';
    this.desktopImageSrcSet = this.getDesktopImageSrcSet();

    // Same handling for the mobile background image with the cast. The input type is ContentfulCloudinaryImage.
    const mobileImage = changes.cloudinaryBackgroundImageMobileAsset?.currentValue as ContentfulCloudinaryImage;
    // If there is no mobile image, we use the desktop image on mobile to avoid a white background.
    this.cloudinaryBackgroundImageMobileUrl = mobileImage?.asset?.fields.file?.url ?? this.cloudinaryBackgroundImageUrl;
    this.cloudinaryBackgroundImageMobileAlt = mobileImage?.alternateText ?? this.cloudinaryBackgroundImageAlt;

    const hasImageMobile = mobileImage ? true : false;
    this.mobileImageSrcSet = this.getMobileImageSrcSet(!hasImageMobile);
  }

  getDesktopImageSrcSet(): string {
    return (
      this.cloudinaryBackgroundImageUrl +
      '?fm=webp&q=75&w=1024 1024w,' +
      this.cloudinaryBackgroundImageUrl +
      '?fm=webp&q=75&w=1920 1920w,' +
      this.cloudinaryBackgroundImageUrl +
      '?fm=webp&q=75&w=3840 3840w'
    );
  }

  getMobileImageSrcSet(useImageDesktopOnMobile: boolean): string {
    // If the mobile image is the same as the desktop image, we return a srcset with more quality options becouse the image was displayed pixelated on mobile.
    if (useImageDesktopOnMobile) {
      return this.cloudinaryBackgroundImageMobileUrl + '?fm=webp&q=75&w=1536 1536w';
    }

    return (
      this.cloudinaryBackgroundImageMobileUrl +
      '?fm=webp&q=75&w=768 768w,' +
      this.cloudinaryBackgroundImageMobileUrl +
      '?fm=webp&q=75&w=1536 1536w'
    );
  }
}
